// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"57":"9b3d53a1","169":"0103e1f4","360":"c16e6fcf","400":"d6baa1d9","867":"6e3b1a70"}[chunkId] + ".css";
};